/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_SubtitleInputs */

const en_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything included in each plan at a glance.`)
};

const de_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles auf einen Blick, was in jedem Plan enthalten ist.`)
};

const fr_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout ce qui est inclus dans chaque plan en un coup d'oeil.`)
};

const es_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo lo incluido en cada plan de un vistazo.`)
};

const it_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto ciò che è incluso in ogni piano a colpo d'occhio.`)
};

const nl_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles wat in elk plan zit in één oogopslag.`)
};

const pl_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystko, co zawiera każdy plan w jednym widoku.`)
};

const fi_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki mitä jokainen suunnitelma sisältää yhdellä silmäyksellä.`)
};

const da_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alt hvad der er inkluderet i hver plan med ét blik.`)
};

const sv_pricing_compare_subtitle = /** @type {(inputs: Pricing_Compare_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allt som ingår i varje plan med en blick.`)
};

/**
* | output |
* | --- |
* | "Everything included in each plan at a glance." |
*
* @param {Pricing_Compare_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_subtitle = /** @type {((inputs?: Pricing_Compare_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_subtitle(inputs)
	if (locale === "fr") return fr_pricing_compare_subtitle(inputs)
	if (locale === "es") return es_pricing_compare_subtitle(inputs)
	if (locale === "it") return it_pricing_compare_subtitle(inputs)
	if (locale === "nl") return nl_pricing_compare_subtitle(inputs)
	if (locale === "pl") return pl_pricing_compare_subtitle(inputs)
	if (locale === "fi") return fi_pricing_compare_subtitle(inputs)
	if (locale === "da") return da_pricing_compare_subtitle(inputs)
	if (locale === "sv") return sv_pricing_compare_subtitle(inputs)
	return en_pricing_compare_subtitle(inputs)
});